import React, { memo } from 'react'
import CarrierStatus from 'components/marketplace/CarrierStatus'
import { TCarrierStatus } from 'types'
import { SafetyIcon } from 'transfix-icons'
import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'

export interface ICarrierCardProps {
  legalName?: string
  fmcsaState: string
  stateName?: TCarrierStatus
  isTrusted?: boolean
  shipmentsCount: number
  bounceRate: number
  onTimePickup: string
  primaryManager?: { fullName: string }
}

export const CarrierCard = memo<ICarrierCardProps>(
  ({
    bounceRate,
    fmcsaState,
    isTrusted,
    legalName,
    onTimePickup,
    primaryManager,
    shipmentsCount,
    stateName,
  }) => (
    <>
      <div className='pv2 ph4'>
        <p>{isTrusted ? `${legalName} (Preferred Carrier)` : legalName}</p>
        <div>
          <span className='mr4'>
            <SafetyIcon /> {capitalize(fmcsaState) || DISPLAY.empty}
          </span>
          <CarrierStatus status={stateName} displayStatus />
        </div>
        <p>
          <span className='text-secondary'>Primary Manager:</span>
          &nbsp;
          <span className='text-default'>{primaryManager?.fullName || 'N/A'}</span>
        </p>
      </div>
      <div className='flex justify-around items-center bg-secondary tc pa2'>
        <div className='flex-grow-1'>
          <p>{shipmentsCount || DISPLAY.empty}</p>
          <p className='text-secondary'>Shipments</p>
        </div>
        <div className='flex-grow-1'>
          <p>{bounceRate || DISPLAY.empty}%</p>
          <p className='text-secondary'>Bounce Rate</p>
        </div>
        <div className='flex-grow-1'>
          <p>{onTimePickup || DISPLAY.empty}%</p>
          <p className='text-secondary'>OTP</p>
        </div>
      </div>
    </>
  )
)
